import { useEffect } from "react";

const BRAND = "4Ever";
const SITE_URL = "https://4ever.co.in";
const DEFAULT_IMAGE = `${SITE_URL}/img/g1_hero.webp`;
const DEFAULT_IMAGE_ALT = "4ever Freedom Disposable Period Panty pack";

function setTag(selector, attr, value) {
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [name, val] = selector.replace("meta[", "").replace("]", "").split("=");
    el.setAttribute(name, val.replace(/"/g, ""));
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

function setLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!data) { if (el) el.remove(); return; }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function useSEO({ title, description, path = "/", jsonLd, breadcrumbs, image, imageAlt, type = "website" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${BRAND}` : `${BRAND} — Women's Wellness`;
    document.title = fullTitle;

    if (description) {
      setTag('meta[name="description"]', "content", description);
      setTag('meta[property="og:description"]', "content", description);
      setTag('meta[name="twitter:description"]', "content", description);
    }
    setTag('meta[property="og:title"]', "content", fullTitle);
    setTag('meta[name="twitter:title"]', "content", fullTitle);

    const canonical = `${SITE_URL}${path === "/" ? "/" : path}`;
    setLink("canonical", canonical);
    setTag('meta[property="og:url"]', "content", canonical);
    setTag('meta[property="og:type"]', "content", type);

    const img = image ? `${SITE_URL}${image}` : DEFAULT_IMAGE;
    setTag('meta[property="og:image"]', "content", img);
    setTag('meta[property="og:image:alt"]', "content", imageAlt || DEFAULT_IMAGE_ALT);
    setTag('meta[name="twitter:image"]', "content", img);
    setTag('meta[name="twitter:card"]', "content", "summary_large_image");

    setJsonLd("jsonld-page", jsonLd);
    setJsonLd("jsonld-breadcrumbs", breadcrumbs && breadcrumbs.length ? {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: breadcrumbs.map((b, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: b.name,
        item: `${SITE_URL}${b.path}`,
      })),
    } : null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, image, imageAlt, type, JSON.stringify(jsonLd || {}), JSON.stringify(breadcrumbs || [])]);
}
